<ts-button
  [text]="isMobile ? 'New' : 'What\'s New'"
  icon-end="keyboard_arrow_down"
  color="base"
  appearance="text"
  [class.expanded]="isExpanded"
  (clickFn)="onClick()"
></ts-button>

<ng-template #carouselTemplate>
  <app-new-feature-carousel></app-new-feature-carousel>
</ng-template>
